const fontColor = '#333'
const mainColor = '#1359c3'
const highlightColor = '#7eaa3d'
const borderColor = '#8dbb4f'
const buttonColor = '#222'
const buttonBackgroundColor = '#bceb70'
const buttonBackgroundColorHover = '#b2e16a'
const widgetBackgroundColor = '#cee2fa'

const buttonStyles = {
  color: buttonColor,
  background: buttonBackgroundColor,
  border: borderColor,
  hover: {
    background: buttonBackgroundColorHover,
    border: borderColor
  }
}

export default {
  name: 'atlas',
  header: {
    logo: {
      bottom: 0,
      height: 37
    },
    holidayLogo: {
      top: 9
    },
    search: {
      sections: {
        color: '#949494',
        activeColor: highlightColor
      },
      form: {
        autocomplete: {
          color: highlightColor
        },
        input: {
          borderColor: borderColor,
          borderColorFocus: borderColor,
          color: fontColor
        }
      }
    },
    christmastips: {
      color: fontColor,
      highlightColor
    },
    email: {
      indicatorColor: highlightColor,
      linkColor: mainColor
    }
  },
  covid: {
    textHover: highlightColor
  },
  dynamicLead: {
    firstBox: {
      backgroundColor: mainColor,
      backgroundColorHover: '#0f4ca7',
      color: 'white'
    },
    smallBox: {
      color: fontColor
    }
  },
  mobileTabs: {
    background: widgetBackgroundColor
  },
  email: {
    summary: {
      background: widgetBackgroundColor,
      registrationLink: {
        color: mainColor,
        colorHover: highlightColor
      },
      checkbox: {
        colorChecked: highlightColor
      },
      submit: {
        color: buttonColor,
        border: borderColor,
        borderRadius: '0 4px 4px 0',
        background: buttonBackgroundColor,
        borderHover: borderColor,
        backgroundHover: buttonBackgroundColorHover
      },
      input: {
        border: '#999',
        borderFocus: '#888',
        borderRadius: '0'
      }
    },
    full: {
      color: mainColor,
      subject: {
        color: mainColor,
        colorHover: highlightColor
      },
      toggleIcon: {
        background: `${STATICS_PATH}images/email/arrow-atlas.png`
      }
    }
  },
  weather: {
    button: buttonStyles
  },
  exchange: {
    button: buttonStyles
  },
  tip: {
    background: widgetBackgroundColor,
    color: mainColor
  },
  footer: {
    color: fontColor,
    colorLink: fontColor
  },
  services: {
    color: mainColor
  },
  jobs: {
    arrowUrl: `${STATICS_PATH}images/jobs/arrow-atlas.png`,
    color: mainColor,
    colorHover: highlightColor
  },
  newsfeed: {
    button: buttonStyles
  },
  headline: {
    color: mainColor,
    colorHover: highlightColor
  },
  moreLink: {
    color: mainColor,
    colorHover: highlightColor
  },
  link: {
    colorHover: highlightColor
  },
  coronaHighlight: {
    color: highlightColor
  },
  featured: {
    video: {
      backgroundColor: buttonBackgroundColor,
      borderColor: borderColor,
      color: buttonColor,
      iconInvert: '100%'
    }
  },
  button: buttonStyles,
  regional: {
    color: buttonColor,
    newLabelBorder: borderColor,
    newLabelBackground: buttonBackgroundColor
  }
}
